import React from 'react';
import { FaGraduationCap, FaCertificate } from 'react-icons/fa';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>

        <div className="about-content">
          <div className="about-text">
            <p className="about-intro">
              I'm a content strategist at FanSided, where I manage 100+ monthly articles for Rip City Project covering all things Portland Trail Blazers. My specialties include SEO and data-driven optimization, which have helped our site rank among the top performers in the division. With a background in marketing and tech, I love the creative and analytical aspects of content marketing. I'm looking to join a team where I can apply both to help drive growth.
            </p>
          </div>
        </div>

        <div className="education-section">
          <div className="credential-header">
            <FaGraduationCap className="credential-icon" />
            <h3>Education & Certifications</h3>
          </div>
          <div className="credential-item">
            <h4>Bachelor of Science, Business Administration</h4>
            <p className="credential-detail">Marketing Concentration</p>
            <p className="credential-school">University of Arizona</p>
            <span className="credential-year">2013-2017</span>
          </div>
          <div className="credential-item">
            <h4>Full-Stack Web Development & Computer Science</h4>
            <p className="credential-school">Bloom Institute of Technology</p>
            <span className="credential-year">2019-2021</span>
          </div>
          <div className="credential-item">
            <h4>Technical Writing</h4>
            <p className="credential-school">Oregon State University</p>
            <span className="credential-year">2021-2022</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;